function isEmailValid (input) {
  let emailRegExp = new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
  return emailRegExp.test(input)
}

function isPostalcodeValid (input) {
  let postalcodeRegExp = new RegExp(/^(?:\d{5})?$/)
  return postalcodeRegExp.test(input)
}

function isTelephoneValid (input) {
  let telephoneRegExp = new RegExp(/^(?:(?:\+|00)33|0)\s*[1-9](?:[\s.-]*\d{2}){4}$/)
  return telephoneRegExp.test(input)
}

export function isInputValid (inputType, value) {
  switch (inputType) {
    case 'mail':
      return isEmailValid(value)
    case 'postalcode':
      return isPostalcodeValid(value)
    case 'tel':
      return isTelephoneValid(value)
    default:
      return !!value
  }
}
